import type { IDrugDevStatusIndexField, IOrganizationOwnershipType, IOrgType } from '@patsnap/synapse_common_interface'
import { IBAcLabelOptions, IOrganizationFinderType } from '../types'

export const organizationTypeIconMap: Record<IOrgType, string> = {
  Company: 'Company',
  Education: 'University',
  Government: 'Government',
  Nonprofit: 'Government',
}

export const ownershipTypeIconMap: Record<IOrganizationOwnershipType, string> = {
  Public: 'PublicCompany',
  Holding: 'HoldingCompany',
  'Joint Venture': 'JointVentureCompany',
  Private: 'Company',
  Subsidiary: 'SubsidiaryCompany',
}

export const organizationFinderOptions: IBAcLabelOptions<IOrganizationFinderType>[] = [
  {
    name_cn: '在研/非在研机构',
    name_en: 'Active/Inactive Org.',
    val: 'Active/Inactive',
  },
  {
    name_cn: '原研/在研/非在研机构',
    name_en: 'Original/Active/Inactive Org.',
    val: 'Original/Active/Inactive',
  },
  {
    name_cn: '权益/原研/在研/非在研机构',
    name_en: 'License/Original/Active/Inactive Org.',
    val: 'License/Original/Active/Inactive',
  },
]

export const organizationFinderValField: { val: IOrganizationFinderType; fields: IDrugDevStatusIndexField[] }[] = [
  {
    val: 'Active/Inactive',
    fields: ['ORGANIZATION_ID_ONEID'],
  },
  {
    val: 'Original/Active/Inactive',
    fields: ['ORIGINAL_DEV_ORG_ID_ONEID', 'ORGANIZATION_ID_ONEID'],
  },
  {
    val: 'License/Original/Active/Inactive',
    fields: ['LICENSE_ORG_ID_ONEID', 'ORIGINAL_DEV_ORG_ID_ONEID', 'ORGANIZATION_ID_ONEID'],
  },
]
